import { all, takeLatest, call, put } from 'redux-saga/effects';
import ECActionTypes from './types';
import Services from 'services';
import {
  fetchEmergencyContactsFailure,
  fetchEmergencyContactsSuccess,
  getECGeocodeSuccess,
  getECGeocodeFailure
} from './actions';
import { getGeocodeByCoordinate } from 'services/map.service';

// EmergencyContacts
function* handleEmergencyContacts(req: any) {
  try {
    const res: any = yield call(
      Services.common.fetchEmergencyContactsService,
      req.payload
    );

    if (res) {
      yield put(fetchEmergencyContactsSuccess(res));
    } else {
      fetchEmergencyContactsFailure(res?.err);
    }
  } catch (err) {
    yield put(fetchEmergencyContactsFailure(err));
  }
}

function* handleGetGeocode(request: any) {
  const emptyErrorText =
    'Unable to get address from geocode API. Please retry.';
  try {
    const response = yield call(
      getGeocodeByCoordinate,
      request.payload.datasets,
      request.payload.longitude,
      request.payload.latitude
    );
    if (response?.Results && response.Results instanceof Array) {
      const geocode = response.Results[0];
      if (geocode) {
        yield put(getECGeocodeSuccess(geocode));
      } else {
        yield put(getECGeocodeFailure(emptyErrorText));
      }
    } else {
      yield put(getECGeocodeFailure(emptyErrorText));
    }
  } catch (err) {
    const msg = err?.message || err.toString();
    put(getECGeocodeFailure(msg));
  }
}

function* watchEmergencyContacts() {
  yield takeLatest(
    ECActionTypes.EMERGENCY_CONTACTS_START,
    handleEmergencyContacts
  );
}

function* watchGetGeocode() {
  yield takeLatest(ECActionTypes.GET_EC_GEOCODE_START, handleGetGeocode);
}

function* emergencyContactsSagas() {
  yield all([call(watchEmergencyContacts), call(watchGetGeocode)]);
}
export default emergencyContactsSagas;
